import themeConfig from "./themes.json";

/** 与 Uno preflight、`theme.colors` 一致；用于 `var(--edgen-<key>)` */
export const EDGEN_THEME_COLOR_CSS_VAR_PREFIX = "--edgen-" as const;

function toEdgenThemeColorVar(colorKey: string): string {
  return `var(${EDGEN_THEME_COLOR_CSS_VAR_PREFIX}${colorKey})`;
}

/** 将 themes.json 色值 → :root 内 `--edgen-*: hex` 声明块 */
export function serializeEdgenColorVars(
  flatColors: Record<string, string>,
): string {
  const prefix = EDGEN_THEME_COLOR_CSS_VAR_PREFIX;
  return Object.entries(flatColors)
    .filter(([, v]) => typeof v === "string" && v.length > 0)
    .map(([key, value]) => `  ${prefix}${key}: ${value};`)
    .join("\n");
}

/**
 * 从 themes.json 规范色构建 Uno preflight 与 theme.colors，保证 ospThemes.colors 与 Uno 同源。
 */
export function buildEdgenUnoColorPipeline(
  canonicalThemeColors: typeof themeConfig.colors,
) {
  const edgenHexColorVars = {
    ...canonicalThemeColors,
  } as Record<string, string>;

  const themeColors = Object.fromEntries(
    Object.keys(edgenHexColorVars).map((key) => [
      key,
      toEdgenThemeColorVar(key),
    ]),
  ) as Record<string, string>;

  return { edgenHexColorVars, themeColors };
}
